import QRCode from "react-qr-code";

const QrCode = (props) => {

    const {value, desc, size = 256, centered = true, small = false} = props


    return (
        <div className={`qr-wrapper ${small ? 'small' : ''} ${centered ? 'centered' : ''}`}>
            <div className="form__qr">
                <QRCode
                    bgColor={'transparent'}
                    // fgColor={'var(--tf-active)'}
                    fgColor={'var(--tf-tc)'}
                    style={{height: "auto", maxWidth: "100%", width: "100%"}}
                    value={value || ''}
                    viewBox={`0 0 ${size} ${size}`}
                />
            </div>
            <p>{desc}</p>
        </div>
    )
}


export default QrCode
